import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=9b820ffc&scoped=true&"
import script from "./Verify.vue?vue&type=script&lang=tsx&"
export * from "./Verify.vue?vue&type=script&lang=tsx&"
import style0 from "./Verify.vue?vue&type=style&index=0&id=9b820ffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b820ffc",
  null
  
)

export default component.exports